import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useMediaQuery } from "@mui/material";
import { DashboardComp } from "../components/dashboard/DashboardView";
import { FFRCatalog } from "../components/FFRs/FFRCatalog";
import { AreaFieldReportView } from "../components/AFRs/areaFieldReportView";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
var AreaFieldReports = function () {
    var dispatch = useAppDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var assignedMenus = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "tab",
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "tab",
                    panelGridProps: {
                        px: 3
                    },
                    tabs: [{
                            id: "0",
                            label: "Dashboard",
                            element: DashboardComp
                        }, {
                            id: "1",
                            label: "FFRs",
                            element: FFRCatalog
                        }, {
                            id: "2",
                            label: "AFRs",
                            element: AreaFieldReportView
                        }],
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable",
                    sx: {
                        margin: "0px 24px"
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: []
        // getFormAPI={FieldFailureReportsGetAPI}
        // mode="edit"
        // getKey={AreaFieldReportsKeys.count}
        // getRequest={{id:'becf120e-c1b6-4699-839d-f67a1bf2936f'}}
        ,
        gridProps: {
            spacing: 0
        }
        // onChange={(e, { state, field, value }) => {
        //     handlePagingUpdate(state);
        // }}
    }));
};
export default AreaFieldReports;
